<template>
  <label class="emd-radio-button" :for="id" :class="getSize">
    <input
      class="emd-radio-button__input"
      type="radio"
      :id="id"
      :name="name"
      :disabled="disabled"
      :value="value"
      :checked="isChecked"
      @change="$emit('change', $event.target.value)"
    >
    <div class="emd-radio-button__area"></div>
    <span class="emd-radio-button__text">{{label}}</span>
  </label>
</template>

<script>
export default {
  name: 'EmdRadio',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    size: {
      type: String,
      required: false,
      default: null
    },
    id: {
      type: String,
      required: false,
      default: null
    },
    name: {
      type: String,
      required: false,
      default: null
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    modelValue: {
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isChecked () {
      return this.modelValue === this.value
    },
    getSize () {
      return this.size && `_size_${this.size}`
    }
  }
}
</script>
